import {Box} from '@mui/material';
import {SnackbarKey, useSnackbar} from 'notistack';
import React from 'react';
import {DialogButton} from './CreateGoal';
import {useReviewContext} from '../../../contexts/ReviewContext';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';

export interface GoalButtonsProps {
  advance: () => void;
  fallback: () => void;
  activeStep: number;
  submitting: boolean;
  handleSubmit: () => void;
  maxStep: number;
  handleClose: () => void;
  validateForm?: () => void;
  style?: React.CSSProperties;
}

export const onSavingGoalFactory = ({
  closeSnackbar,
  handleSubmit,
}: {
  closeSnackbar: (key?: SnackbarKey | undefined) => void;
  handleSubmit: () => void;
}) => {
  return () => {
    closeSnackbar();
    handleSubmit();
  };
};

export function GoalButtons(props: GoalButtonsProps) {
  const {
    advance,
    fallback,
    activeStep,
    handleClose,
    handleSubmit,
    submitting,
    maxStep,
    ...restProps
  } = props;
  const {errors} = useAutoForm();
  const {closeSnackbar} = useSnackbar();
  const {enqueueSnackbar} = useSnackbar();
  const onSavingGoal = onSavingGoalFactory({
    closeSnackbar,
    handleSubmit,
  });
  const {isFullySubmitted} = useReviewContext();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...restProps}>
      <DialogButton onClick={handleClose}>Cancel</DialogButton>
      <DialogButton onClick={fallback} disabled={activeStep <= 0}>
        Back
      </DialogButton>
      {/* I realise that the button is similar to next, but it will help with selling it to the advisers */}
      {activeStep <= 0 ? null : (
        <DialogButton
          onClick={activeStep < maxStep ? advance : onSavingGoal}
          disabled={submitting}
        >
          Skip
        </DialogButton>
      )}
      {activeStep >= maxStep ? null : (
        <DialogButton onClick={advance} disabled={activeStep >= maxStep}>
          Next
        </DialogButton>
      )}
      {activeStep < maxStep ? null : (
        <DialogButton
          variant="contained"
          onClick={() => {
            if (Object.keys(errors).length) {
              enqueueSnackbar({
                variant: 'error',
                message: `Error: ${JSON.stringify(Object.values(errors).join('...'))}`,
              });
            } else {
              onSavingGoal();
            }
          }}
          disabled={activeStep < maxStep || submitting || isFullySubmitted}
        >
          {submitting ? 'Saving...' : 'Save'}
        </DialogButton>
      )}
    </Box>
  );
}
